// import scope from './scope';
import NavigationsPublic from './public';

import StuffToEat from './stuff-to-eat';
import Program from './program';
import Person from './person';
import Workspace from './workspace';
import Settings from './settings';
import SystemAdministration from './system-administration';

const NavigationsAuthorized = [];

NavigationsAuthorized.push({
  label: 'label.home',
  url: '/professional/home',
  exact: true,
  type: 'section',
  navigationIcon: 'far fa-home',
  pages: [
    {
      name: 'professional-home',
      url: '/professional/home',
      exact: true,
      label: 'label.dashboard',
      navigationIcon: 'far fa-home',
    },
  ],
});

NavigationsAuthorized.push(Program);
NavigationsAuthorized.push(Person);
NavigationsAuthorized.push(StuffToEat);
NavigationsAuthorized.push(Workspace);
NavigationsAuthorized.push(Settings);
NavigationsAuthorized.push(SystemAdministration);

// NavigationsAuthorized.push({
//   label: 'label.stuff_to_do',
//   name: '',
//   type: 'section',
//   url: '/stuff-to-do',
//   navigationIcon: 'far fa-watch',
//   scope: SCOPES.PROFESSIONAL,
//   pages: [
//     {
//       label: 'label.basic_activities',
//       name: '',
//       url: '/stuff-to-do/basic-activities',
//       navigationIcon: 'icon-ca-running',
//       scope: SCOPES.PROFESSIONAL,
//     },
//     {
//       label: 'label.exercises',
//       name: '',
//       url: '/stuff-to-do/exercises',
//       navigationIcon: 'icon-ca-skipping',
//       scope: SCOPES.PROFESSIONAL,
//     },
//     {
//       label: 'label.workouts',
//       name: '',
//       url: '/stuff-to-do/workouts',
//       navigationIcon: 'icon-ca-stopwatch',
//       scope: SCOPES.PROFESSIONAL,
//     },
//   ],
// });

// NavigationsAuthorized.push({
//   label: 'label.activities',
//   name: '',
//   url: '/activities',
//   navigationIcon: 'far fa-info',
//   scope: SCOPES.INSTANCE_STAFF,
//   type: 'section',
//   pages: [
//     {
//       label: 'label.messages',
//       name: '',
//       url: 'logout',
//       navigationIcon: 'icon-ca-message',
//       subscriptionFeature: 'message',
//     },
//     {
//       label: 'label.notifications',
//       name: '',
//       url: 'logout',
//       navigationIcon: 'icon-ca-bell',
//       subscriptionFeature: 'notifications',
//     },
//   ],
// });


export { NavigationsPublic, NavigationsAuthorized };



// WEBPACK FOOTER //
// ./src/data/navigations/index.js